/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Pricerules_Mock_Editor_TitleInputs */

const tr_landing_pricerules_mock_editor_title = /** @type {(inputs: Landing_Pricerules_Mock_Editor_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kural Editörü`)
};

const en_landing_pricerules_mock_editor_title = /** @type {(inputs: Landing_Pricerules_Mock_Editor_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rule Editor`)
};

const de_landing_pricerules_mock_editor_title = /** @type {(inputs: Landing_Pricerules_Mock_Editor_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regel-Editor`)
};

const ru_landing_pricerules_mock_editor_title = /** @type {(inputs: Landing_Pricerules_Mock_Editor_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Редактор правил`)
};

/**
* | output |
* | --- |
* | "Rule Editor" |
*
* @param {Landing_Pricerules_Mock_Editor_TitleInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_pricerules_mock_editor_title = /** @type {((inputs?: Landing_Pricerules_Mock_Editor_TitleInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Pricerules_Mock_Editor_TitleInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_pricerules_mock_editor_title(inputs)
	if (locale === "de") return de_landing_pricerules_mock_editor_title(inputs)
	if (locale === "ru") return ru_landing_pricerules_mock_editor_title(inputs)
	return tr_landing_pricerules_mock_editor_title(inputs)
});